// extracted by mini-css-extract-plugin
export var currencyInput = "_jg-1";
export var currencySymbol = "_jg-0";